export default import.meta.ROLLUP_FILE_URL_9euV$7GXtGVutMzsRhG$jA